import React from 'react'
import TabMUI from '@material-ui/core/Tab'

function Tab(props) {
  const {classes, ...otherProps} = props

  return (
    <TabMUI
      classes={{
        root: `audit__tab ${classes?.root ? ` ${classes.root}` : ''}`,
      }}
      {...otherProps}
    />
  )
}

Tab.displayName = 'Tab'

export default Tab
